<template>
  <div id="app">
    <div class="main">
      <div>
        <div
          data-v-a6c0f666=""
          style="background: center top / cover no-repeat rgb(255, 181, 186); position: relative;"
        >
          <div
            data-v-a6c0f666=""
            :style="'background: url('+topUrl+') center top / cover no-repeat; top: 0px; width: 100%; height: 300px; position: fixed;'"
          ></div>
          <div
            data-v-a6c0f666=""
            style="height: 150px;"
          ></div>
          <div class="example-3d">

            <swiper
              class="swiper"
              :options="swiperOption"
            >
              <template v-for="(item,index) in carouselArr">
                <swiper-slide
                  class="swiper-slide"
                  :key="index"
                  v-if="item==='vido'"
                >
                  <video-player
                    class="video-player vjs-custom-skin"
                    style="width: 100%;"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions"
                  ></video-player>
                </swiper-slide>
                <swiper-slide
                  v-else
                  class="swiper-slide"
                  :key="index"
                >
                  <img
                    style="width:100%;"
                    :src="item"
                  />
                </swiper-slide>
              </template>
            </swiper>
          </div>
          <div
            data-v-35209de0=""
            data-v-a6c0f666=""
            class="register_pannel"
            style="margin-left: 20px; margin-right: 20px; background: white; border: 0.5px solid white; border-radius: 1%; position: relative; z-index: 1;"
          >
            <div
              data-v-35209de0=""
              style="height: 40px; padding-top: 15px; padding-bottom: 20px; display: flex; background: center top / cover no-repeat;"
            ><img
                data-v-35209de0=""
                src="../assets/head.jpg"
                style="width: 48px; height: 48px; border-radius: 50%; margin-left: 23px;"
              >
              <div
                data-v-35209de0=""
                style="margin-left: 10px; margin-top: 12px; text-align: left;"
              >
                <div
                  data-v-35209de0=""
                  style="font-size: 14px; color: black;"
                >我正在用恋爱聊天术跟女朋友聊天</div>
              </div>
            </div>
            <div
              data-v-35209de0=""
              style="display: flex; flex-direction: column; align-items: center;"
            >
              <div
                data-v-35209de0=""
                :style="'width: 268px; height: 108px; margin-left: 27.5px; margin-bottom: 40px; margin-right: 37px; display: flex; flex-direction: column; background: url('+vipUrl+') center top / cover no-repeat;'"
              >
                <!-- <div
                  data-v-35209de0=""
                  style="color: rgb(83, 39, 1); font-size: 20px; margin-top: 28.5px; letter-spacing: -0.96px;"
                >免费送你3天VIP会员</div>
                <div
                  data-v-35209de0=""
                  style="color: rgb(133, 85, 7); font-size: 14px; margin-top: 3px;"
                >12W话术让你跟女神聊到飞起</div> -->
              </div>
              <!-- <input
                data-v-35209de0=""
                type="button"
                value="立即下载"
                class="button"
                style="margin-bottom: 18px;"
                @click="download"
              > -->
              <div class="download clearfix">
                <img
                  :src="code"
                  alt=""
                >
                <div class="down-btn">
                  <img
                    src="../assets/android.jpg"
                    alt=""
                    @click="download('android')"
                  >
                  <img
                    src="../assets/ios.jpg"
                    alt=""
                    @click="download('ios')"
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            data-v-12918d24=""
            data-v-a6c0f666=""
            style="margin-left: 20px; margin-top: 10px; margin-right: 20px; background: white; border: 0.5px solid white; border-radius: 1%; position: relative; z-index: 1;"
          >
            <div
              data-v-12918d24=""
              style="margin-top: 30px; font-size: 16px; color: black;"
            >恋爱聊天术</div>
            <div data-v-12918d24="">
              <div
                data-v-12918d24=""
                class="sub-intro"
              ><img
                  data-v-12918d24=""
                  src="../assets/ic_h5_vip1.png"
                  style="width: 11%; height: 11%;"
                >
                <div
                  data-v-12918d24=""
                  class="sub-intro-text"
                >
                  <div data-v-12918d24="">首创【搜索女生说的话】聊天助手神器</div>
                  <div
                    data-v-12918d24=""
                    class="sub-intro-sub-text"
                  >不会和女生聊天，只需要复制女生说的话，即可搜索到精彩回复，帮助提高自己的恋爱聊天思维</div>
                </div>
              </div>
              <div
                data-v-12918d24=""
                class="sub-intro"
              ><img
                  data-v-12918d24=""
                  src="../assets/ic_h5_vip2.png"
                  style="width: 11%; height: 11%;"
                >
                <div
                  data-v-12918d24=""
                  class="sub-intro-text"
                >
                  <div data-v-12918d24="">恋爱技巧，恋爱干货</div>
                  <div
                    data-v-12918d24=""
                    class="sub-intro-sub-text"
                  >网聊技巧，表白指南，聊天技巧，大龄脱单，备胎转正，异地恋情，相亲攻略，分手挽回，确定关系等让你恋爱如开挂</div>
                </div>
              </div>
              <div
                data-v-12918d24=""
                class="sub-intro"
              ><img
                  data-v-12918d24=""
                  src="../assets/ic_h5_vip3.png"
                  style="width: 11%; height: 11%;"
                >
                <div
                  data-v-12918d24=""
                  class="sub-intro-text"
                >
                  <div data-v-12918d24="">情感小绝招，让爱不在孤单</div>
                  <div
                    data-v-12918d24=""
                    class="sub-intro-sub-text"
                  >快速提高你的情商爱商</div>
                </div>
              </div>
              <div
                data-v-12918d24=""
                class="sub-intro"
              ><img
                  data-v-12918d24=""
                  src="../assets/ic_h5_vip4.png"
                  style="width: 11%; height: 11%;"
                >
                <div
                  data-v-12918d24=""
                  class="sub-intro-text"
                >
                  <div data-v-12918d24="">实用小工具</div>
                  <div
                    data-v-12918d24=""
                    class="sub-intro-sub-text"
                  >海量聊天表情包，朋友圈展示面，表白小工具</div>
                </div>
              </div>
              <div
                data-v-12918d24=""
                class="sub-intro"
              ><img
                  data-v-12918d24=""
                  src="../assets/ic_h5_vip33.png"
                  style="width: 11%; height: 11%;"
                >
                <div
                  data-v-12918d24=""
                  class="sub-intro-text"
                >
                  <div data-v-12918d24="">Ai恋爱聊天话术</div>
                  <div
                    data-v-12918d24=""
                    class="sub-intro-sub-text"
                  >百万恋爱聊天话术库，总有你想要的答案</div>
                </div>
              </div>
              <div
                data-v-12918d24=""
                style="height: 1px; width: 92%; background: rgb(238, 238, 238); margin-left: 10px; margin-right: 10px; margin-top: 30px;"
              ></div>
            </div>
          </div>
          <div style="margin-left: 20px; margin-top: 10px; margin-right: 20px; background: white; border: 0.5px solid white; border-radius: 1%; position: relative; z-index: 1;">
            <div class="item">
              <span class="line"></span>用户最新评论
            </div>
            <div
              class=""
              onclick="return false"
            >
              <img
                style="width: 100%"
                src="../assets/small_logo.gif"
                alt=""
              >
            </div>
            <div class="list">
              <div
                class="comment"
                v-for="(item,index) in arrComments"
                :key="index"
              >
                <div class="user">
                  <div class="user-l"><img
                      class="avatar"
                      :src="item.head"
                      alt=""
                    >
                    <div class="name"><span>{{item.name}}</span><span class="time">{{time}}</span></div>
                  </div>
                  <div><img
                      style="width: 70px"
                      src="../assets/star.png"
                      alt=""
                    ></div>
                </div>
                <div class="user-text">
                  {{item.content}}
                </div>
              </div>
            </div>
            <div class="footer">
              <div
                class="left-wrapper"
                @click="toCompany"
              >
                <p>长沙市德茂文化有限公司</p>
                <p>湘ICP备20001945号 版权所有</p>
              </div>
            </div>
          </div>
          <div
            data-v-a6c0f666=""
            style="height: 60px;"
          ></div>
        </div>
      </div>
    </div>
    <!-- <div
      class="zzc"
      v-show="showCode"
      @click="hide"
    ></div>
    <div
      :class="['tishi',showCode?'aniBlow':'aniHide']"
      @click="hide"
      v-show="showCode"
    >
      <img
        :src="code"
        alt=""
      >
      <div class="info">请扫描二维码下载哦~~~</div>
    </div> -->
    <div
      class="wechat-modal"
      style="position: fixed; top: 0px; left: 0px; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.8); z-index: 9999999;"
      v-show="showWX"
      @click="hide"
    >
      <div
        class="bg android"
        style="width:100%;height:100%;background-size: 100%;background-repeat: no-repeat;background-image: url(data:image/png;base64,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);"
      ></div>
    </div>
  </div>

</template>
<script>

export default {
  name: 'home',
  data () {
    return {
      arrComments: [{
        name: '最靓的仔',
        content: '超级推荐这个软件，我复制女生说的话，就能搜到答案，太爽了，不用担心不会聊天了',
        head: require('../assets/jtb-avatar-7553.jpg')
      }, {
        name: '下任校草',
        content: '真心话，这个软件真的挺好的，话术全功能多，应该是市面上最好的了',
        head: require('../assets/jtb-avatar-7557.jpg')
      }, {
        name: '正经人',
        content: '打开软件随便找个段子，哄得女生开心大笑',
        head: require('../assets/jtb-avatar-7560.jpg')
      }, {
        name: '孤独患者',
        content: '这软件太好了，解决了我很多聊天问题',
        head: require('../assets/jtb-avatar-7565.jpg')
      }, {
        name: '嘉人1988',
        content: '以前总是不会聊天，和妹子总是尬聊，现在好了，搜一搜就能找到高情回复，真的太好了',
        head: require('../assets/jtb-avatar-7568.jpg')
      }, {
        name: '秦哥哥',
        content: '先提前看一下相亲技巧，这样相亲时就知道聊啥了，这样就不会尴尬啦',
        head: require('../assets/jtb-avatar-7572.jpg')
      }, {
        name: '根正苗红',
        content: '话术全功能多，赞一个',
        head: require('../assets/jtb-avatar-7574.jpg')
      }, {
        name: '一座城池',
        content: '给舍友也推荐了，好兄弟要一起开心',
        head: require('../assets/jtb-avatar-7583.jpg')
      }],
      code: '',
      showCode: false,
      time: '',
      showWX: false,
      topUrl: require('../assets/ic_h5_bd.jpeg'),
      vipUrl: require('../assets/ic_h5_vip.png'),
      swiperOption: {
        effect: 'coverflow',
        initialSlide: 1,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
          rotate: 40,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      carouselArr: [
        require('../assets/1.png'),
        'vido',
        // require('../assets/2.png'),
        require('../assets/3.png'),
        require('../assets/4.png')
      ],
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '1242:2208', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: "http://app.slhs777.com/%E6%81%8B%E7%88%B1%E8%81%8A%E5%A4%A9%E6%9C%AF.mp4" //url地址
        }],
        poster: require('../assets/2.png'), //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: false  //全屏按钮
        }
      }

    };
  },
  mounted () {
    // this.swiper.slideTo(2, 1000, false)
  },
  created () {
    document.title = '高情商聊天术-聊天回复神器';
    //设置时间
    var date = new Date();
    this.time = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate();
    var href = window.location.href;
    this.code = 'https://s.8979.com/share/qrcode?w=300&h=300&url=' + href

  },
  methods: {
    // download: function () {
    //   var _this = this;
    //   var u = navigator.userAgent;
    //   var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
    //   var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    //   if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    //     if (u.toLowerCase().match(/MicroMessenger/i) == "micromessenger" && isAndroid) {
    //       _this.showWX = true;
    //     } else if (isAndroid) {
    //       document.location = 'https://appstore.huawei.com/app/C101708429';
    //     } else if (isIOS) {
    //       // appStore下载地址
    //       document.location = 'https://apps.apple.com/cn/app/id1498364478';
    //     }
    //   } else {
    //     _this.showCode = true;
    //   }
    //   window.zhad.push({ eventtype: 'js_submit' })
    // },
    download: function (type) {
      if (type === 'android') {
        document.location = 'https://appstore.huawei.com/app/C101708429';
      } else {
        // appStore下载地址
        document.location = 'https://apps.apple.com/cn/app/id1498364478';
      }

      window.zhad.push({ eventtype: 'js_submit' })
    },
    hide: function () {
      this.showCode = false;
      this.showWX = false;
    },
    toCompany: function () {
      document.location = 'http://beian.miit.gov.cn';
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../assets/css/home.css";
.clearfix {
  zoom: 1;
}
.clearfix:after {
  clear: both;
  height: 0px;
  font-size: 0px;
  visibility: hidden;
  display: block;
  content: " ";
}
img {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.main {
  /* max-width: 750px; */
  margin: 0 auto;
}

.btn {
  width: 100%;
  margin: 0 auto;
  position: fixed;
  text-align: center;
  left: 0;
  bottom: 0px;
}

.btn img {
  width: 100%;
  max-width: 750px;
  display: block;
  margin: 0 auto;
}

.popup span {
  position: absolute;
  right: 10px;
  top: 10px;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 5px;
  background-color: transparent;
  padding: 6px 15px;
}

.video-js .vjs-icon-placeholder {
  width: 45%;
  height: 45%;
  display: block;
}

.item {
  width: 90%;
  margin: 0 auto;
  text-align: left;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 20px;
}

.line {
  border-left: 6px solid #2685fb;
  padding-right: 12px;
}

#QRCode img {
  width: 30%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#message {
  background-color: #474a51;
  padding: 10px;
  color: #fff;
  height: 50px;
  position: relative;
}

#message img {
  position: absolute;
  height: 50px;
  width: 50px;
  right: 10px;
  top: 10px;
}

.avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}

.comment {
  width: 90%;
  margin: 0 auto;
  margin-top: 20px;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
}

.user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.user-l {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.name {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  align-items: flex-start;
}

.time {
  font-size: 12px;
  color: #969696;
  margin-top: 5px;
}

.user-text {
  font-size: 14px;
  color: #474a51;
  margin: 20px 0;
  text-align: left;
}

.s-right img {
  width: 100%;
}

.s-left img {
  width: 100%;
}

.pc-d-btn img {
  width: 220px;
}

.return_top img {
  width: 100%;
  height: 100%;
}

.true_btn {
  width: 75%;
  height: 50px;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  top: 88px;
}

.footer {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
  overflow: hidden;
  font-size: 14px;
}
.footer .left-wrapper {
  text-align: center;
  width: 100%;
}

.download {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.download img {
  width: 50%;
  float: left;
}
.download .down-btn {
  width: 50%;
  float: left;
}

.down-btn img {
  margin-top: 35px;
  width: 100%;
  /* height: 35px; */
}
.tishi {
  z-index: 99;
  position: fixed;
  margin: auto;
  top: 30%;
  left: 0;
  right: 0;
}
.tishi img {
  display: block;
  margin: 0 auto;
  width: 300px;
}
.tishi .info {
  margin-top: 15px;
  font-size: 24px;
  color: #fff;
  text-align: center;
}

.zzc {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9;
}
.aniBlow {
  animation: aniBlow 0.3s ease-out both;
}
.aniHide {
  animation: aniHide 0.3s ease-out both;
}

.example-3d {
  width: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
}
.swiper {
  height: 100%;
  width: 100%;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 55%;
  height: 100%;
  background-position: center;
  background-size: cover;
}
@media screen and (min-width: 500px) {
  .swiper {
    height: 100%;
    width: 500px;
  }

  .download {
    width: 400px;
    margin: 0 auto;
  }
}
@keyframes aniBlow {
  0% {
    transform: scale(0.1, 0.1);
  }
  75% {
    transform: scale(1.2, 1.2);
  }
  100% {
    transform: scale(1, 1);
  }
}
@keyframes aniHide {
  0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1.2, 1.2);
  }
  100% {
    transform: scale(0.1, 0.1);
  }
}
</style>
